<template>
	<page>
		<module enable-flex>
			<c-table ref="list" height="grow" :paging="false">

				<c-table-column
					label="广告位"
					name="position_name"
					width="140"
					fixed="left"
				></c-table-column>

				<c-table-column
					label="标题"
					name="title"
					width="140"
				>
					<template #default="{data}">
						<span v-if="data.title" class="ellipsis" :title="data.title">{{ data.title }}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="客户端类型"
					name="type"
					width="110"
				>
					<template #default="{data}">
						<c-state tag async dict="AD_TYPE" :value="data.type"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					label="图片"
					name="image_url"
					width="160"
				>
					<template #default="{data}">
						<c-file v-if="data.image_url" class="image" :src="data.image_url" media style="width:120px;height:60px;object-fit:cover;"></c-file>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="本地地址"
					name="local_url"
					width="110"
				>
					<template #default="{data}">
						<span v-if="data.local_url" class="ellipsis" :title="data.local_url">{{ data.local_url }}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="跳转地址"
					name="link_url"
					width="200"
				>
					<template #default="{data}">
						<span v-if="data.link_url" class="ellipsis" :title="data.link_url">{{ data.link_url }}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="小程序APPID"
					name="jump_app_id"
					width="200"
				>
					<template #default="{data}">
						<span v-if="data.jump_app_id">{{ data.jump_app_id }}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="状态"
					name="state"
					width="100"
					fixed="right"
				>
					<template #default="{data}">
						<c-switch v-if="auth('b_mall_ad_info_state') && data.id" v-model="data.state" :state-value="[1, 2]"
							:state-text="['启用','禁用']"
							@beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
						<c-state v-else dict="disableEnableDic" :value="data.state"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="145"
					button-limit="6"
					fixed="right"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_mall_ad_info_edit')" icon="tf-edit" @click="$refs.adInfoEdit.open(data)">编辑</c-table-button>
<!--						<c-table-button v-if="auth('b_mall_ad_info_del')" icon="tf-trash" color="red" @click="removeAd(data)">删除</c-table-button>-->
					</template>
				</c-table-column>
			</c-table>
			<!--新增/编辑广告内容弹窗-->
			<ad-info-edit ref="adInfoEdit" :position-options="positionOptions" @resolve="$refs.list.update()"></ad-info-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import adInfoEdit from "@/pages/mall/ad_info_edit.vue";

	export default {
		components: {
			adInfoEdit,
		},
		computed: {
			...mapState(['disableEnableDic'])
		},

		data() {
			return {
				positionOptions: []
			}
		},

		mounted() {
			this.loadPositions();
			this.searchHandle();
		},

		methods: {
			/********加载广告位下拉************/
			loadPositions() {
				this.request({
					url: '/mall/ad_position/all',
					loading: false,
					success: data => {
						this.positionOptions = Array.from(data || [], item => {
							return {
								name: item.position_name,
								value: item.id,
								data: item
							}
						});
					}
				});
			},

			/********搜索************/
			searchHandle(data) {
				if (!data) {
					data = {};
				}
				this.$refs.list.load({
					url: '/mall/ad_info/list',
					data
				});
			},

			/******启禁用*********/
			stateHandle(state, next, data) {
				this.request({
					url: '/mall/ad_info/update_state',
					data: {
						id: data.id,
						state: state ? 2 : 1
					},
					loading: true,
					success: () => {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						next();
					}
				});
			},

			/******删除广告内容**********/
			removeAd(data) {
				this.$confirm({
					message: '确认删除该广告内容？删除后不可恢复',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/mall/ad_info/delete',
							data: {
								id: data.id
							},
							loading: true,
							success: data => {
								this.$message({
									message: '删除成功',
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},
					cancel: () => {},
				});
			},

			/******排序**********/
			sortHandle(row, type, next) {
				this.request({
					url: '/mall/ad_info/sort',
					data: {
						id: row.data.id,
						position_id: row.data.position_id,
						type: ['top', 'bottom'].includes(type) ? type : '',
						id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
						id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
					},
					loading: true,
					success: data => {
						// next();
                        this.$refs.list.update();
                    }
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
